import { createSelector } from '@reduxjs/toolkit';

import { OrthographicDesignCamera } from '../../three/OrthographicDesignCamera';
import { getActiveCameraOrNull } from '../../three/reactThreeFiberBindings';
import {
  getBoundsOfActiveComponentDesignWithoutDimensions,
  getInsertionProfileBoundsOrNull,
} from '../selectors/boundsSelectors';
import { selectorHandlerFactory } from './utility';

export const getDesignCameraZoomCapBoundingBoxSize = createSelector(
  getInsertionProfileBoundsOrNull,
  getBoundsOfActiveComponentDesignWithoutDimensions,
  (insertionProfileBounds, activeComponentDesignBounds) => {
    if (insertionProfileBounds) return insertionProfileBounds.size;
    if (activeComponentDesignBounds) return activeComponentDesignBounds.size;
    return null;
  },
);

export const designCameraZoomCapBoundingBoxSizeHandler = selectorHandlerFactory(
  getDesignCameraZoomCapBoundingBoxSize,
  (change) => {
    const activeCamera = getActiveCameraOrNull();
    if (activeCamera instanceof OrthographicDesignCamera) {
      activeCamera.setBoundingBoxSizeOfActiveComponent(change.currentState);
    }
  },
);
